/// <reference path="../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var Reporting;
    (function (Reporting) {
        var ReportingController = /** @class */ (function () {
            function ReportingController($filter, $location, $routeParams, $timeout, $window, applicationService, authenticationService, ssoService, appSettings, reportsListData) {
                this.$filter = $filter;
                this.$location = $location;
                this.$routeParams = $routeParams;
                this.$timeout = $timeout;
                this.$window = $window;
                this.applicationService = applicationService;
                this.authenticationService = authenticationService;
                this.ssoService = ssoService;
                this.appSettings = appSettings;
                this.reportsListData = reportsListData;
                this.loadTimer = 100;
                this.noOrg = false;
                this.noReports = false;
                this.redirectTimer = 5000;
                this.reportLoading = true;
                this.isRedCap = false;
                this.avenueUrl = this.appSettings.urls.avenueWeb;
                this.userOrg = this.$routeParams.organizationCacheKey || undefined;
                this.isRedCap = this.$location.search().thirdparty === ThirdParty.RedCap;
                this.init();
            }
            ReportingController.prototype.init = function () {
                var _this = this;
                if (!ap.Utilities.isNullOrUndefined(this.$routeParams.organizationCacheKey) && this.authenticationService.authorizationData.LoginSystem === 'SSO') {
                    this.applicationService.getReports().then(function (reportsListData) {
                        if (!ap.Utilities.isNullOrUndefined(reportsListData)) {
                            _this.reportsListData = reportsListData;
                        }
                        else if (_this.isRedCap) {
                            var logoutURL = _this.appSettings.urls.sso + "/#/failedlogin?redirect=" + encodeURIComponent(window.location.href) + "&clientId=" + _this.appSettings.applicationCacheKey;
                            window.location.href = logoutURL;
                        }
                        else {
                            _this.noReports = true;
                        }
                        _this.$timeout(function () {
                            _this.reportLoading = false;
                        }, _this.loadTimer);
                    });
                }
                else if (this.authenticationService.authorizationData.LoginSystem !== 'SSO') {
                    // WP Reports
                    this.applicationService.getReports().then(function (reportsListData) {
                        if (!ap.Utilities.isNullOrUndefined(reportsListData)) {
                            _this.reportsListData = reportsListData;
                        }
                        else {
                            _this.noReports = true;
                        }
                        _this.$timeout(function () {
                            _this.reportLoading = false;
                        }, _this.loadTimer);
                    });
                }
                else {
                    this.offerUserList();
                    this.reportLoading = false;
                }
            };
            ReportingController.prototype.offerUserList = function () {
                var _this = this;
                this.ssoService.renewAccessToken().then(function () {
                    var userOrgList = _this.ssoService.getUserOrgListWithProducts();
                    _this.validOrgList = userOrgList.filter(function (x) { return (x.applicationRoles.indexOf(AutoPointRole.EnterpriseReportsUser) > -1 ||
                        x.applicationRoles.indexOf(AutoPointRole.DealerReportsUser) > -1); });
                    if (_this.validOrgList.length > 0) {
                        _this.noOrg = true;
                    }
                    else {
                        _this.noReports = true;
                    }
                });
            };
            ReportingController.prototype.updateUserOrg = function () {
                this.$location.path("/reports/" + this.userOrg);
            };
            ReportingController.$inject = [
                '$filter',
                '$location',
                '$routeParams',
                '$timeout',
                '$window',
                'applicationService',
                'authenticationService',
                'ssoService',
                'appSettings'
            ];
            return ReportingController;
        }());
        Reporting.ReportingController = ReportingController;
        var REPORTING_DISPLAY_COMPONENT = {
            controller: ReportingController,
            controllerAs: 'ctrl',
            templateUrl: 'app/reporting/index.html'
        };
        angular.module('app.Reporting')
            .component('reportingDisplay', REPORTING_DISPLAY_COMPONENT);
    })(Reporting = app.Reporting || (app.Reporting = {}));
})(app || (app = {}));
